import { HTTP_INTERCEPTORS, provideHttpClient } from '@angular/common/http';
import { ApplicationConfig, ErrorHandler, inject, provideAppInitializer, provideZoneChangeDetection } from '@angular/core';
import { provideRouter } from '@angular/router';
import { NgbModal } from '@ng-bootstrap/ng-bootstrap';
import { AuthService } from '@ortho-next/auth-core';
import { firstValueFrom, map, of, switchMap } from 'rxjs';
import { routes } from './app.routes';
import { initAuth } from './auth.config';
import { APP_CONFIG, HttpErrorInterceptor, initializeAppConfig, LanguageService, MonitoringErrorHandler } from './core';
import { UserService } from './services';


export async function initApp(authSrv: AuthService, usrSrv: UserService, langSrv: LanguageService) {
	return firstValueFrom(authSrv.isDoneLoading$.pipe(
		map(() => !!authSrv.accessToken),
		switchMap(isAuth => isAuth ? usrSrv.loadUser() : of(null)),
		switchMap(usr => usr ? langSrv.loadLabels(usr.language) : of(null))
	));
}

export const appConfig: ApplicationConfig = {
	providers: [
		provideZoneChangeDetection({ eventCoalescing: true }),
		provideRouter(routes),
		provideHttpClient(),
		provideAppInitializer(() => initAuth(inject(AuthService), inject(APP_CONFIG), inject(NgbModal))),
		provideAppInitializer(() => initApp(inject(AuthService), inject(UserService), inject(LanguageService))),
		provideAppInitializer(() => initializeAppConfig(inject(APP_CONFIG))),
		{ provide: ErrorHandler, useClass: MonitoringErrorHandler },
		{ provide: HTTP_INTERCEPTORS, useClass: HttpErrorInterceptor, multi: true }
	]
};
